import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import * as React from 'react';

import { TYPE_SCALE, FONT_WEIGHTS, LINE_HEIGHT } from '@/components/design-system/tokens';
import { cn } from '@/lib/utils';

const labelVariants = cva(
  `${TYPE_SCALE.sm} ${FONT_WEIGHTS.medium} ${LINE_HEIGHT.none} peer-disabled:cursor-not-allowed peer-disabled:opacity-70 select-text`
);

type LabelProps = React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, ...props }, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
  )
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
